import { AttachmentConstants } from './utils/attachmentConstants';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "AttachmentModelStore", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded actions
export var lazyAddAndInitializeAttachments = new LazyAction(lazyModule, function (m) { return m.addAndInitializeAttachments; });
export var lazySetPreviewImageUrl = new LazyAction(lazyModule, function (m) { return m.setPreviewImageUrl; });
export var lazyRefreshDownloadUrl = new LazyAction(lazyModule, function (m) { return m.refreshDownloadUrl; });
export var lazyRefreshThumbnailImageUrl = new LazyAction(lazyModule, function (m) { return m.refreshThumbnailImageUrl; });
export var lazyRefreshPreviewImageUrl = new LazyAction(lazyModule, function (m) { return m.refreshPreviewImageUrl; });
// Delay loaded imports
export var lazyGetAttachment = new LazyImport(lazyModule, function (m) { return m.getAttachment; });
export var lazyCheckPendingAttachmentOperation = new LazyImport(lazyModule, function (m) { return m.checkPendingAttachmentOperation; });
export var lazyShouldShowImageView = new LazyImport(lazyModule, function (m) { return m.shouldShowImageView; });
// SatchelV3 actions:
export { refreshSharingTipsForAttachment } from './actions/satchelV3Actions/publicActions';
export { AttachmentClass, AttachmentConstants, AttachmentOperationType, AttachmentUrlType, TypeOfAttachment, };
export { default as attachmentStore } from './store/store';
//# sourceMappingURL=index.js.map